"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderReadOnlyPiece = exports.useRenderMatchPiece = exports.useRenderSelectablePiece = void 0;
const react_1 = __importDefault(require("react"));
const context_1 = require("~/auth/context");
const piece_1 = require("../piece");
const useRenderSelectablePiece = () => function (piece) {
    return react_1.default.createElement(piece_1.SelectablePiece, { piece: piece });
};
exports.useRenderSelectablePiece = useRenderSelectablePiece;
const useRenderMatchPiece = () => {
    const viewingPlayerId = (0, context_1.useAccountId)();
    return function (piece) {
        return react_1.default.createElement(piece_1.MatchPiece, { piece: piece, viewingPlayerId: viewingPlayerId });
    };
};
exports.useRenderMatchPiece = useRenderMatchPiece;
const useRenderReadOnlyPiece = () => function (piece) {
    return react_1.default.createElement(piece_1.Piece, { piece: piece });
};
exports.useRenderReadOnlyPiece = useRenderReadOnlyPiece;
